import React, {lazy, Suspense} from 'react';
import Modal from '../../Components/Modal';
import { preload } from '../../Services/helpers';
import { googleKey } from '../../Services/Keys';
import { PageLoading } from '../../Components/Loading';
const ThePatchMap  = lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "patchMap" */'./ThePatchMap'));

const MyPatch = ({isOpen, onClose, onSave}) => {

    preload(`https://maps.googleapis.com/maps/api/js?key=${googleKey}&v=weekly&language=en&region=gb&callback=initMap`);

    return <Modal isOpen={isOpen} setIsOpen={onClose} title="My Patch" dismissible>

        <p>Move the markers to highlight the area where you provide services.</p>

        {isOpen && <Suspense fallback={<PageLoading />}>
            <ThePatchMap onSave={onSave} onClose={onClose} />
        </Suspense>}
    </Modal>
}

export default MyPatch;
